module.exports = __webpack_public_path__ + "static/img/3s-platform-img3.e290439.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/web/3s-platform-img3.png
// module id = LS12
// module chunks = 0